export default function Logo() {
  return (
    <>
      <div className="@container w-full dark:hidden">
        <img
          src="/logos/studexam/studexam-logo-full.png"
          alt="StudExam Logo"
          className="w-48 h-auto hidden @[50px]:block mx-auto"
        />

        <img
          src="/logos/studexam/studexam-logo.png"
          alt="StudExam Logo"
          className="w-48 h-auto block @[50px]:hidden mx-auto"
        />
      </div>

      <div className="@container w-full dark:block hidden">
        <img
          src="/logos/studexam/studexam-logo-full-white.png"
          alt="StudExam Logo"
          className="w-48 h-auto hidden @[50px]:block mx-auto"
        />

        <img
          src="/logos/studexam/studexam-logo-white.png"
          alt="StudExam Logo"
          className="w-48 h-auto block @[50px]:hidden mx-auto"
        />
      </div>
    </>
  );
}
